<template lang="pug">
	.user-add(v-if="showed")
		.card
			.card-header
				i.fa.fa-edit
				span Add new user
			.card-body.collapse.show(v-show="state === 'idle' || state === 'processing'")
				.form-horizontal
					.form-group
						label.col-form-label(for="name") User name (not email)
							.controls
								input.form-control(id="name" size="16" type="text" v-model="name")
					.form-actions
						button.btn.btn-primary(type="submit" @click="create()" :disabled="!name || state !== 'idle'")
							i.fa.fa-plus
							| &nbsp;&nbsp;Create invitation link
						button.btn.btn-dark(type="button" @click="hide()") Cancel
			.card-body.collapse.show(v-show="state === 'result'")
				.result
					.text(v-if="user")
						a(:href="`${domain}/invitation/${user['linkedin_id'].substr(12)}`" target="_blank") {{`${domain}/invitation/${user['linkedin_id'].substr(12)}`}}
					.form-actions
						button.btn.btn-primary(type="submit" @click="Layout.copyTextToClipboard(`${domain}/invitation/${user['linkedin_id'].substr(12)}`)" v-b-tooltip.click="{delay: { show: 200, hide: 100 }, title: 'Copied!'}")
							i.fa.fa-copy
							| &nbsp;&nbsp;Copy link
						button.btn.btn-dark(type="button" @click="hide()") Close

</template>

<script>

	import Screen 				from './../../mixins/screen'

	import { Settings } 		from './../../services/Settings'

	import SetupSettings 		from '../../settings/settings.json'

	export default {
		name: "AddUser",
		mixins: [Screen],
		screen: {
			events: {
				"User Invitation Created": function(user) {
					this.state = 'result';
					this.user = user;
					Layout.setPage('publisher-invitations');
				}
			}
		},
		data() {

			this.Settings = Settings;

			this.publisher = null;
			this.user = null;

			return {
				domain: SetupSettings['dev'] ? `${location.protocol}//${SetupSettings['domain']}:${SetupSettings['port']}` : `https://${SetupSettings['domain']}`,
				state: 'idle', //'result'
				name: ''
			};

		},
		computed: {
		},
		methods: {
			collectData(reason, publisher) {

				if (reason === 'show') {

					this.publisher = publisher;

					this.state = 'idle';

				}

			},
			create() {

				Server.sendToServer({
					CreateUserInvitation: {
						publisherId: this.publisher.id,
						name: this.name
					}
				});

				this.state = 'processing';

			},
			close() {

				this.state = 'idle';

				this.hide();

			}
		}
	}
</script>


<style lang="sass">

	.user-add
		position: absolute
		z-index: 2000
		left: 0
		top: 0
		right: 0
		bottom: 0
		background-color: rgba(0, 0, 0, 0.6)

		.card
			width: 500px
			position: absolute
			left: 0
			right: 0
			top: 0
			bottom: 0
			margin: auto
			display: flex
			height: 230px
			box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8)

			input
				width: 460px
				margin-top: 5px

			.btn-ghost-dark, .btn-dark
				float: right
				color: #fff

			.form-actions
				position: absolute
				right: 19px
				bottom: 20px
				width: calc(100% - 40px)

		.processing
			height: 100%
			display: flex
			flex-direction: column
			align-items: center
			justify-content: center

			.icon
				display: inline
				font-size: 30px

		.result

			textarea
				width: 100%
				height: 250px
				background: transparent
				border: none
				color: #fff
				font-size: 12px
				white-space: pre
				overflow-wrap: normal
				overflow-x: auto
</style>

